import { CancelMortgageInsuranceRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCancelMortgageInsurance = makeValidator({
  FieldParser: CancelMortgageInsuranceRow,
});
